import { configureStore } from '@reduxjs/toolkit'
import appReducer from './reducer/app-reducer'
import authReducer from './reducer/auth-reducer'

export default configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer
    },
})